import Hero from "./hero/hero.jsx";
import Bids from "./bids/bids.jsx";
import Trending_category from "./categories/trending_categories.jsx";
import HeadLine from "./headLine.jsx";
import Hero_3 from "./hero/hero_3.jsx";

export {
  Hero,
  Bids,
  Trending_category,
  HeadLine,
  Hero_3,
};
